// extracted by mini-css-extract-plugin
export default {"mobileBreakpoint":"767","tabletBreakpoint":"999","verticalOrientedBreakpoint":"1319","reports__advantages":"reports-module--reports__advantages--Amw2r"};